module.exports = (__parcel__import__("kUA5g")).then(() => parcelRequire('GLD9c'));